import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class NoteService {
	constructor(private http: HttpClient) { }

	get(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.note:get',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	set(id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.note:set',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	types(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.note:types',
			params: {
				
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
}
